/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from "../icetypes";

export class expensejournal extends IceEntity {
  expense_journal_key: string = "";
  other_items_key: string = "";
  other_items_receiving_key: string = "";
  medical_service_key: string = "";
  trans_account: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  last_name: string = "";
  coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  journal_date: any = NaN;
  journal_desc: string = "";
  quantity: number = 0.0;
  debit: number = 0.0;
  credit: number = 0.0;
  record_version: number = 0;
  offline_record_status: number = 0;
  accounting_period_key: string = "";
  entry_type: IceTypes.journal_entry_type = IceTypes.journal_entry_type.jetGeneral;

  constructor(copy?: expensejournal) {
    super();

    if (copy != null) {
      this.expense_journal_key = copy.expense_journal_key;
      this.other_items_key = copy.other_items_key;
      this.other_items_receiving_key = copy.other_items_receiving_key;
      this.medical_service_key = copy.medical_service_key;
      this.trans_account = copy.trans_account;
      this.account_type = copy.account_type;
      this.last_name = copy.last_name;
      this.coa_type = copy.coa_type;
      this.journal_date = copy.journal_date;
      this.journal_desc = copy.journal_desc;
      this.quantity = copy.quantity;
      this.debit = copy.debit;
      this.credit = copy.credit;
      this.record_version = copy.record_version;
      this.offline_record_status = copy.offline_record_status;
      this.accounting_period_key = copy.accounting_period_key;
      this.entry_type = copy.entry_type;
    }
  }

  gettablename(): string {
    return "EXPENSE_JOURNAL";
  }
}
